import { memberApi } from '../config/axios-config';

export const getInsuranceDetails = (tenantInfo)=> {
    return memberApi.get('/v3/my/other-insurance', {
        headers: { 'tenant-id': tenantInfo }
      });
};